<div class="absolute right-0 top-0" (click)="close()">
  <ark-lib-icon-name name="close"></ark-lib-icon-name>
</div>
<div class="flex flex-col p-5">
  <div class="text-zinc-600 text-base font-semibold leading-relaxed">
    Think Tank Solution
  </div>
  <div class="w-[280px] text-zinc-600 text-base font-normal leading-[21px]">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
    quis nostrud exercitation Lorem ipsum dolor sit amet, consectetur adipiscing
    elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    Lorem ipsum dolor sit amet, consectetur.
  </div>
</div>
